import { React, useState, useEffect, useContext, useCallback } from 'react';
import P from 'prop-types';
import './styles.css';
import { LabelForm } from '../LabelForm';
import { InputText } from '../InputText';
import { Button } from '../Button';
import { toast } from 'react-toastify';
import { GlobalContext } from '../../contexts/HomeContext';
import { GetCep, GetDistance, SalvarEndereco } from '../../utils/api/api';
import { GoogleMap } from '@react-google-maps/api';
import { isObjectEmpty } from '../../utils/utils';

export const EnderecoNovo = ({ param }) => {
  const { user, dadosApp } = useContext(GlobalContext);
  const [dados, setDados] = useState({
    cep: '',
    endereco: '',
    endereco_bairro: '',
    endereco_cidade: '',
    endereco_estado: '',
    endereco_numero: '',
    endereco_complemento: '',
    titulo: param.isFatura ? 'FATURA' : 'CASA',
    codigo_cliente: user.id,
    idloja: dadosApp.IdLoja,
  });

  const google = window.google;
  const center = {
    lat: parseFloat(dadosApp.Empresa.Empresa.latitude.replace(',', '.')),
    lng: parseFloat(dadosApp.Empresa.Empresa.longitude.replace(',', '.')),
  };

  const obterLatitudeLongitude = async () => {
    let AreaModel;
    const geocoder = new google.maps.Geocoder();

    // solução provisória para o cliente de cabreuva,
    // enquanto a google nao reconhece os novos ceps
    if (dados.endereco_cidade?.trim()?.toUpperCase() === 'CABREÚVA') {
      dados.cep = '13315000';
      dados.endereco_bairro = dados.endereco_bairro?.toUpperCase().replace('PORTAL CONCÓRDIA', 'Portal da Concórdia');
    }

    await geocoder.geocode(
      {
        address: `${dados.endereco}, ${dados.endereco_numero} ${dados.endereco_bairro} ${dados.endereco_cidade}, ${dados.cep}, Brasil`,
        region: 'BR',
      },
      function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            let latitude = results[0].geometry.location.lat();
            let longitude = results[0].geometry.location.lng();
            AreaModel = new google.maps.LatLng(latitude, longitude);
          }
        }
      },
    );

    return AreaModel;
  };

  const clearForm = () => {
    setDados({
      cep: '',
      endereco: '',
      endereco_bairro: '',
      endereco_cidade: '',
      endereco_estado: '',
      endereco_numero: '',
      endereco_complemento: '',
      titulo: param.isFatura ? 'FATURA' : 'CASA',
      codigo_cliente: user.id,
      idloja: dadosApp.IdLoja,
    });
    param.endereco = {};
  };

  const buscarCep = async () => {
    param.showHideLoading();
    let response = await GetCep(dados.cep);
    param.setLoading(false);
    if (response.data.erro) {
      toast.error('CEP Inválido!', {
        containerId: 'modalToast',
      });
      return;
    }
    if (response.data.Retorno == 1) {
      toast.error(response.data.Retorno.msg, {
        containerId: 'modalToast',
      });
      return;
    }

    let data = {
      ...dados,
      endereco: response.data.logradouro.replaceAll("'", '').replaceAll('"', ''),
      endereco_bairro: response.data.bairro.replaceAll("'", '').replaceAll('"', ''),
      endereco_cidade: response.data.localidade.replaceAll("'", '').replaceAll('"', ''),
      endereco_estado: response.data.uf.replaceAll("'", '').replaceAll('"', ''),
    };
    setDados({ ...data });
  };

  const handleInputs = (event) => {
    const target = event.target;

    // LIMITA A DIGITAÇÃO DO CEP PARA 8 CARACTERES
    if ([target.name][0] == 'cep' && target.value.length == 9) return;

    dados[target.name] = target.value.replaceAll("'", '').replaceAll('"', '');
    if ([target.name][0] == 'cep' && target.value.length < 8) {
      setDados({
        ...dados,
        endereco: '',
        endereco_bairro: '',
        endereco_cidade: '',
        endereco_estado: '',
        endereco_numero: '',
        endereco_complemento: '',
      });
    } else {
      setDados({ ...dados });
    }

    if ([target.name][0] == 'cep' && target.value.length == 8) buscarCep();
  };

  const handleOnSelectTitulo = (titulo) => {
    setDados({
      ...dados,
      titulo: titulo,
    });
  };

  const temAtendimento = async () => {
    if (param.isFatura) return true;

    let latLng = await obterLatitudeLongitude();
    let retorno = false;

    for (let i = 0; i < dadosApp.Empresa.Area.length; i++) {
      const item = dadosApp.Empresa.Area[i];
      const areaAtendimento = [];
      const arrayCoordenadas = item.area?.split('|');
      arrayCoordenadas?.forEach((coordenada) => {
        const latLng = coordenada.split(',');
        areaAtendimento.push(new google.maps.LatLng(latLng[0], latLng[1]));
      });

      const areaDefinida = new google.maps.Polygon({ paths: areaAtendimento });
      retorno = google.maps.geometry.poly.containsLocation(latLng, areaDefinida);

      if (retorno) {
        // const objDistance = {
        //   origin: dadosApp.Empresa.Empresa.latitude + ',' + dadosApp.Empresa.Empresa.longitude,
        //   destination: latLng.lat() + ',' + latLng.lng(),
        // };

        let origin = dadosApp.Empresa.Empresa.latitude + ',' + dadosApp.Empresa.Empresa.longitude;
        let destination = latLng.lat() + ',' + latLng.lng();

        const byAddress = dadosApp.IdLoja === 15157; // se for a loja de Cabreúva, então calcula pelo endereço
        if (byAddress) {
          //origin = `${dadosApp.Empresa.Empresa.endereco}, ${dadosApp.Empresa.Empresa.endereco_numero} - ${dadosApp.Empresa.Empresa.endereco_bairro}, ${dadosApp.Empresa.Empresa.endereco_cidade} - ${dadosApp.Empresa.Empresa.endereco_estado}, ${dados.cep}`;
          destination = `${dados.endereco}, ${dados.endereco_numero} - ${dados.endereco_bairro}, ${dados.endereco_cidade} - ${dados.endereco_estado}, ${dados.cep}`;
        }

        const objDistance = {
          origin: origin,
          destination: destination,
          byAddress: byAddress,
        };

        const newDistance = await GetDistance(objDistance);

        if (newDistance.status != 200) {
          toast.error('Erro ao obter a distância');
          return false;
        }
        if (newDistance.data.rows[0].elements[0].distance == null) {
          toast.error('Erro ao obter a distância');
          return false;
        }
        if (newDistance.data.rows[0].elements[0].distance.value == null) {
          toast.error('Erro ao obter a distância');
          return false;
        }
        dados['distancia'] = newDistance.data.rows[0].elements[0].distance.value;

        let aplicouTaxa = false;
        //obtem o valor da taxa
        let vTaxa = 0;
        switch (dadosApp.Empresa.Config.taxa_tipo) {
          case 'Km':
            dadosApp.TabelaTaxaKm.map((item) => {
              // if (distance >= item.km_inicio * 1000 && distance <= item.km_final * 1000) {
              //   vTaxa = item.valor;
              //   dados['taxa'] = item.valor;
              // }
              if (
                newDistance.data.rows[0].elements[0].distance.value >= item.km_inicio * 1000 &&
                newDistance.data.rows[0].elements[0].distance.value <= item.km_final * 1000
              ) {
                vTaxa = item.valor;
                dados['taxa'] = item.valor;
                aplicouTaxa = true;
              }
            });
            // aplica a MAIOR TAXA caso não tenha encontrado
            // e não tenha aplicado em nenhuma das taxas configuradas
            if (vTaxa == 0 && !aplicouTaxa)
              dados['taxa'] = dadosApp.TabelaTaxaKm[dadosApp.TabelaTaxaKm.length - 1].valor;
            //if (vTaxa == 0) dados['taxa'] = 0;
            break;

          case 'Regiao':
          case 'Região':
            dados['taxa'] = item.valor;
            //dados['taxa_id'] = item.id; // não precisa mais passar o id base
            break;

          default:
            dados['taxa'] = 0;
            break;
        }
        dados['latitude'] = latLng.lat();
        dados['longitude'] = latLng.lng();
        setDados({ ...dados });
        return true;
      }
    }

    if (!retorno) toast.error('Endereço fora da área de atendimento');
    return retorno;
  };

  const validaForm = () => {
    if (dados.endereco_numero == '') {
      toast.error('Informe o número do endereço', { containerId: 'modalToast' });
      return;
    }
    salvarEndereco();
  };

  const salvarEndereco = async () => {
    param.showHideLoading();

    if (param.isFatura) dados.titulo = 'FATURA';

    let resultado = await temAtendimento();
    if (resultado) {
      let response = await SalvarEndereco(dados);
      if (response.data.Retorno) {
        if (response.data.Retorno.status == 1) {
          param.setLoading(false);
          toast.error(response.data.Retorno.msg, { containerId: 'modalToast' });
          return;
        }
      }
      toast.success(`Cadastro ${dados.id ? 'alterado' : 'realizado'} com sucesso!`, {
        containerId: 'modalToast',
      });
      param.handleNewBackAddress(false, true);
    } else {
      param.setLoading(false);
    }
  };

  const carregarEnderecoEdicao = useCallback(() => {
    if (!isObjectEmpty(param.endereco)) {
      setDados(param.endereco);
    }
  }, [param]);

  useEffect(() => {
    carregarEnderecoEdicao();
  }, [carregarEnderecoEdicao]);

  return (
    <>
      <div className="modal-content-dialog" style={{ minHeight: 'auto' }}>
        <GoogleMap center={{ lat: center.lat, lng: center.lng }} />
        <Button
          className="btnWhite btn-shadow"
          text="Meus Endereços"
          icon="chevron_left"
          iconAlign="left"
          onClick={() => param.handleNewBackAddress()}
        />
        <form style={{ minHeight: '350px' }}>
          <div className="form-group">
            <div className="grid-col-2">
              <div style={{ gridColumn: 1 }}>
                <LabelForm text="CEP" labelFor="cep" />
                <InputText
                  type="text"
                  className="form-control input-full"
                  disabled={dados.endereco != '' ? true : false}
                  name="cep"
                  onChange={handleInputs}
                  value={dados.cep}
                />
              </div>
              <div style={{ gridColumn: 2, display: 'flex', paddingLeft: '10px', paddingTop: '1.5rem' }}>
                {dados.endereco != '' && (
                  <Button text="Limpar" className="btnGradient vertical-center" onClick={clearForm} />
                )}
              </div>
            </div>
          </div>
          {dados.endereco != '' && (
            <div>
              <div
                className="clearfix"
                style={{
                  color: '#444',
                  minHeight: '70px',
                  margin: '10px 0',
                  display: 'grid',
                }}
              >
                <p style={{ fontSize: 17 + 'px', fontWeight: 'bold', margin: 'auto' }}>{dados.endereco}</p>
                <p>
                  {dados.endereco_bairro}, {dados.endereco_cidade}
                </p>
              </div>
              {!param.isFatura && (
                <div style={{ textAlign: 'center', margin: 'auto' }}>
                  <div
                    className="btn-select btn-shadow"
                    style={{
                      border: dados.titulo.toUpperCase() == 'CASA' ? '2px solid red' : '2px solid #F2F2F2',
                      cursor: 'pointer',
                      width: '31%',
                      margin: '0',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                    onClick={() => handleOnSelectTitulo('CASA')}
                  >
                    Casa
                  </div>

                  <div
                    className="btn-select btn-shadow"
                    style={{
                      border: dados.titulo.toUpperCase() == 'TRABALHO' ? '2px solid red' : '2px solid #F2F2F2',
                      cursor: 'pointer',
                      width: '32%',
                      margin: '0 3%',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                    onClick={() => handleOnSelectTitulo('TRABALHO')}
                  >
                    Trabalho
                  </div>

                  <div
                    className="btn-select btn-shadow"
                    style={{
                      border: dados.titulo.toUpperCase() == 'OUTRO' ? '2px solid red' : '2px solid #F2F2F2',
                      cursor: 'pointer',
                      width: '31%',
                      margin: '0',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                    onClick={() => handleOnSelectTitulo('OUTRO')}
                  >
                    Outro
                  </div>
                </div>
              )}
              <div className="form-group clearfix">
                <div className="grid-col-2">
                  <div style={{ gridColumn: 1, paddingTop: '20px' }}>
                    <LabelForm text="Número" labelFor="endereco_numero" />
                    <InputText
                      type="text"
                      className="form-control input-full"
                      name="endereco_numero"
                      onChange={handleInputs}
                      value={dados.endereco_numero}
                    />
                  </div>
                  <div style={{ gridColumn: 2, paddingTop: '20px' }}>
                    <LabelForm text="Complemento" labelFor="endereco_complemento" />
                    <InputText
                      type="text"
                      className="form-control input-full"
                      name="endereco_complemento"
                      onChange={handleInputs}
                      value={dados.endereco_complemento}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </form>
      </div>
      {/* <div className="footer-sticky"> */}
      <div style={{ padding: 25 }}>
        <Button
          text="Salvar"
          disabled={dados.endereco == '' ? true : false}
          className="btn_1 btnGradient width-full"
          onClick={validaForm}
        />
      </div>
    </>
  );
};

EnderecoNovo.propTypes = {
  param: P.object,
};
